export default {"src":"/_next/static/media/play-button.60b775e9.svg","height":41,"width":35};